<quill-editor
  placeholder="{{placeholder}}"
  [(ngModel)]="value"
  [modules]="modules"
  (onContentChanged)="onEditorChanged($event)"
></quill-editor>
